export const path = {
  home: "/",
  login: "/login",
  register: "/register",
  logout: "/logout",
  profile: "/dashboard/profile",
  setting: "/dashboard/setting",
  setup: "/dashboard/setup-website",
  dashboard: "/dashboard",
  referral: "/dashboard/referral",
  recovery: "/recovery",
  reset: "/reset-password/:token",
  album: "/dashboard/albums/:albumId",
  albumAno: "/albums/:albumId",
  albumShow: "/show/albums/:albumId",
  servicepackages: "/service-packages",
  packageManagement: "/dashboard/package-management",
  staticpage: "/page/:path",
};
